import * as THREE from 'three';

export const StaticShader = {
    name: 'StaticShader',

    uniforms: {
        tDiffuse: { value: null },
        curvature: { value: 0.2 },
        zoom: { value: 1.05 }, // Boosted default to hide black borders
        gamma: { value: 0.5 },
    },

    vertexShader: /* glsl */ `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader: /* glsl */ `
        uniform sampler2D tDiffuse;
        uniform float curvature;
        uniform float zoom;
        uniform float gamma;
        varying vec2 vUv;

        void main() {
            // 1. Center UVs to [-1, 1]
            vec2 uv = vUv * 2.0 - 1.0;
            
            // 2. Apply Curvature
            vec2 offset = abs(uv.yx) / vec2(curvature);
            uv = uv + uv * (offset * offset * 0.01);
            
            // 3. Apply Zoom and return to [0, 1]
            uv = (uv / zoom) * 0.5 + 0.5;

            // 4. Sample and check bounds
            if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
                gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
            } else {
                vec4 color = texture2D(tDiffuse, uv);
                color.rgb = pow(color.rgb, vec3(gamma));
                gl_FragColor = color;
            }
        }
    `,
};

/**
 * Creates uniforms for the static shader with custom settings
 */
export function createStaticUniforms(
    curvature: number = 0.2,
    zoom: number = 1.05,
    gamma: number = 0.5
): Record<string, THREE.IUniform> {
    return {
        tDiffuse: { value: null },
        curvature: { value: curvature },
        zoom: { value: zoom },
        gamma: { value: gamma },
    };
}